import { Card } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/Feedback';

/**
 * Rangka halaman yang belum dibangun. Sengaja ada rutenya sejak awal supaya
 * navigasi lengkap sejak Fase 0 dan tidak perlu dibongkar ulang.
 */
export function PlaceholderPage({ title, fase }: { title: string; fase: string }) {
  return (
    <div className="flex flex-col gap-5">
      <PageHeader title={title} />
      <Card padded={false}>
        {/* Tanpa `fase`, komponen ini dipakai sebagai halaman 404 — judulnya
            harus ikut berubah. "Belum dibangun" pada alamat yang salah ketik
            terbaca seolah fiturnya sedang digarap, padahal tidak ada. */}
        <EmptyState
          icon={fase ? '🚧' : '🔍'}
          title={fase ? 'Belum dibangun' : 'Alamat tidak dikenal'}
          description={
            fase
              ? `Halaman ini dijadwalkan pada ${fase}. Rutenya sudah disiapkan agar navigasi utuh sejak awal.`
              : 'Periksa kembali alamat yang Anda tuju, atau kembali lewat menu di samping.'
          }
        />
      </Card>
    </div>
  );
}

export function PageHeader({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="text-2xl font-semibold text-ink">{title}</h1>
        {description && <p className="mt-1 text-ink-secondary">{description}</p>}
      </div>
      {action}
    </div>
  );
}
